var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "sidebar__icon",
    width: 17,
    height: 15,
    viewBox: "0 0 17 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.66634 1.66666C5.74586 1.66666 4.99967 2.41286 4.99967 3.33333C4.99967 4.2538 5.74586 4.99999 6.66634 4.99999C7.58681 4.99999 8.333 4.2538 8.333 3.33333C8.333 2.41286 7.58681 1.66666 6.66634 1.66666ZM3.33301 3.33333C3.33301 1.49238 4.82539 0 6.66634 0C8.50728 0 9.99967 1.49238 9.99967 3.33333C9.99967 5.17428 8.50728 6.66666 6.66634 6.66666C4.82539 6.66666 3.33301 5.17428 3.33301 3.33333Z",
    fill: "#E1E1E1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.16666 9.99995C2.78595 9.99995 1.66666 11.1192 1.66666 12.4999V14.1666C1.66666 14.6268 1.29357 14.9999 0.833332 14.9999C0.373096 14.9999 0 14.6268 0 14.1666V12.4999C0 10.1988 1.86548 8.33328 4.16666 8.33328H9.16666C11.4678 8.33328 13.3333 10.1988 13.3333 12.4999V14.1666C13.3333 14.6268 12.9602 14.9999 12.5 14.9999C12.0397 14.9999 11.6667 14.6268 11.6667 14.1666V12.4999C11.6667 11.1192 10.5474 9.99995 9.16666 9.99995H4.16666Z",
    fill: "#E1E1E1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 14.1667C15 14.6269 15.3731 15 15.8333 15C16.2935 15 16.6666 14.6269 16.6666 14.1667V12.5C16.6666 10.2833 14.9356 8.47086 12.7515 8.34084C13.6282 9.1173 14.299 10.1212 14.6713 11.26C14.8804 11.6255 15 12.0488 15 12.5V14.1667Z",
    fill: "#E1E1E1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4165 6.64093C12.0609 6.43601 13.3334 5.03329 13.3334 3.33336C13.3334 1.63343 12.0609 0.230712 10.4165 0.0257874C11.1946 0.90724 11.6668 2.06516 11.6668 3.33336C11.6668 4.60156 11.1946 5.75948 10.4165 6.64093Z",
    fill: "#E1E1E1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.533d4b703b3f3a135b29315cbcc02f0e.svg";
export { ForwardRef as ReactComponent };